import React from "react";
import PropTypes from "prop-types";
import logo from "../../assets/images/Neo_Logo_A.svg";

/**
 * PageLoader
 * Spinner de página inteira centralizado com a Logo do NeoApp.
 */
const PageLoader = ({ loading = true }) => {
    if (!loading) return null;

    return (
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex flex-column align-items-center justify-content-center"
            style={{
                zIndex: 9999,
                backgroundColor: "rgba(255, 255, 255, 0.9)",
                backdropFilter: "blur(4px)"
            }}
        >
            <div className="text-center">
                <img
                    src={logo}
                    alt="NeoApp Logo"
                    className="mb-3 animate-pulse"
                    style={{ width: "80px", height: "auto" }}
                />
                <div className="spinner-border text-primary d-block mx-auto" role="status">
                    <span className="visually-hidden">Carregando...</span>
                </div>
            </div>
        </div>
    );
};

PageLoader.propTypes = {
    loading: PropTypes.bool
};

export default PageLoader;
